var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 13.7913L10.7243 10.0153C11.6317 8.92601 12.0842 7.52877 11.9876 6.1143C11.8911 4.69983 11.2529 3.37704 10.2059 2.42111C9.15892 1.46517 7.78367 0.949686 6.36628 0.981892C4.94889 1.0141 3.59848 1.59151 2.59597 2.59402C1.59347 3.59653 1.01605 4.94694 0.983845 6.36433C0.951639 7.78172 1.46712 9.15696 2.42306 10.204C3.379 11.251 4.70179 11.8891 6.11625 11.9857C7.53072 12.0822 8.92796 11.6297 10.0173 10.7223L13.7933 14.4983L14.5003 13.7913ZM2.0003 6.49835C2.0003 5.60833 2.26422 4.7383 2.75869 3.99828C3.25316 3.25826 3.95596 2.68149 4.77823 2.34089C5.60049 2.0003 6.50529 1.91118 7.37821 2.08482C8.25112 2.25845 9.05295 2.68703 9.68228 3.31637C10.3116 3.9457 10.7402 4.74753 10.9138 5.62044C11.0875 6.49336 10.9984 7.39816 10.6578 8.22042C10.3172 9.04269 9.74039 9.7455 9.00037 10.24C8.26035 10.7344 7.39032 10.9983 6.5003 10.9983C5.30723 10.997 4.16341 10.5225 3.31978 9.67887C2.47616 8.83524 2.00163 7.69142 2.0003 6.49835Z",
    fill: "#C9CACD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b59dbf0798b564de530438a66705891b.svg";
export { ForwardRef as ReactComponent };